import React from "react";
import DebounceInput from "react-debounce-input";
import CloseIcon from "../../../Layout/Icons/CloseIcon";

class CustomQuantity extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.quantity,
      errorMessage: null,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.quantity !== this.props.quantity) {
      this.setState({
        value: this.props.quantity,
      });
    }
  }

  handleOnChange = (event) => {
    this.handleValidateInput(event);
  };

  handleClearInput = () => {
    this.setState({
      value: "",
    });
  };

  handleValidateInput = (event) => {
    const value = event.target.value,
      qtyIncrement = parseInt(this.props.quantityIncrement, 10);

    if (isNaN(value) || value >= 999999) {
      // Verify that the value is a number and below the max quantity
      this.validateInput(value, "Please enter a valid amount");
    } else if (parseInt(value, 10) < parseInt(this.props.minimumQuantity, 10)) {
      // Verify that the value meets the minimum quantity requirements
      this.validateInput(
        value,
        `Minimum quantity for this product is ${this.props.minimumQuantity}`,
      );
    } else if (parseInt(value, 10) % qtyIncrement !== 0) {
      // Verify that the value is an increment of the increment requirements
      this.validateInput(
        value,
        `Quantities for this product must be in increments of ${qtyIncrement}`,
      );
    } else {
      this.validateInput(value, null);
      this.props.handleUpdateQuantity(value);
    }
  };

  validateInput = (value, message) => {
    this.setState({
      value,
      errorMessage: message,
    });
  };

  render() {
    return (
      <div
        className={`quantity__custom ${this.state.errorMessage ? "has-error" : ""}`}
      >
        <div className="custom-qty">
          <div className="custom-qty__text">Custom Amount</div>
          <div className="custom-qty__input">
            <DebounceInput
              type="text"
              debounceTimeout={800}
              onChange={this.handleOnChange}
              value={this.state.value}
            />
          </div>
          <div className="custom-qty__clear" onClick={this.handleClearInput}>
            {this.state.value && <CloseIcon />}
          </div>
        </div>

        {this.state.errorMessage && (
          <div className="custom-qty__error">
            <span>{this.state.errorMessage}</span>
          </div>
        )}
      </div>
    );
  }
}

export default CustomQuantity;
